import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../configuration/config';
import './ResetPassword.css';

const ResetPasswordForm: React.FC = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const validatePassword = (password: string) => {
    const minLength = 6;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    
    if (password.length < minLength) {
      return 'La contraseña debe tener al menos 8 caracteres';
    }
    if (!hasUpperCase) {
      return 'La contraseña debe incluir al menos una letra mayúscula';
    }
    if (!hasNumber) {
      return 'La contraseña debe incluir al menos un número';
    }
    if (!hasSpecialChar) {
      return 'La contraseña debe incluir al menos un carácter especial';
    }
    return '';
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');
    setError('');

    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (password !== confirm) {
      setError('Las contraseñas no coinciden');
      return;
    }

    try {
      const response = await axios.post(
        `${config.API_URL}/users/reset-password/${token}`,
        { password },
        { headers: { 'Content-Type': 'application/json' } }
      );

      setMessage(response.data.message);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        setError(err.response?.data?.message || 'Ocurrió un error');
      } else {
        setError('Ocurrió un error desconocido');
      }
    }
  };

  return (
    <div className="reset-password-container">
      <div className="reset-password-card">
        <div className="reset-password-header">
          <img src="/assets/logo_pro_trans_blue.png" alt="Logo" className="logo_profit mt-4" />
          <h2 className="reset-password-title"><br></br>Restablecer Contraseña</h2>
        </div>
        <form className="reset-password-form" onSubmit={handleSubmit}>
          <div>
            <label>Nueva Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Confirmar Contraseña</label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>
          <button type="submit">Restablecer</button>
        </form>
        <div className="reset-password-header">
            <img className="logo_inetum mt-4" src="/assets/logo_inetum.jpg" alt="logo inetum" />
        </div>
        {message && <p className="reset-password-message">{message}</p>}
        {error && <p className="reset-password-error">{error}</p>}
      </div>
    </div>
  );
};

export default ResetPasswordForm;
